import './styles.scoped.css'
import {useState, useEffect} from 'react'
import {Typography, Button, IconButton, FormControl, OutlinedInput, InputAdornment, FormHelperText, Modal, TextField, Chip} from '@mui/material'
import {Visibility, VisibilityOff, Close, WarningAmberOutlined, CheckCircleOutline} from '@mui/icons-material'
import {useForm} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import * as yup from 'yup'
import {accountApi} from '../../../../services'
import {useGlobalStates} from '../../../../contexts/GlobalStatesContext'
import {useMobile} from '../../../../hooks'
import {parseError} from '../../../../utils/helpers'

export default ({open, setOpen, data}) => {
    const {setLoading, setMessageBox} = useGlobalStates()
    const [showPassword, setShowPassword] = useState(false)
    const {mobile} = useMobile()
    const connected = !!data?.payer?.username
    const form = useForm({
        resolver: yupResolver(
            yup.object().shape({
                username: yup.string().required('Username is required'),
                password: yup.string().required('Password is required'),
            }),
        ),
    })

    useEffect(() => {
        if (!data) {
            form.reset()
        }
    }, [open])

    useEffect(() => {
        if (data) {
            Object.keys(form.getValues()).forEach(field => {
                form.setValue(field, data?.payer?.[field])
            })

            if (!data?.payer?.username) {
                form.setValue('password', '')
            }
        }
    }, [data])

    const changeCredential = body => {
        if (body?.password == '***') {
            body.password = ''
        }
        setLoading(true)
        accountApi
            .updatePayerCredentials(data?.payer?.id, body)
            .then(() => {
                setLoading(false)
                setOpen(false)
                setMessageBox({
                    status: 'success',
                    title: 'Payer Updated Successfully!',
                    description: `The payer details for ${data?.payer?.payer_name} were updated.`,
                })
            })
            .catch(error => {
                setLoading(false)
                const {title, description} = parseError(error)
                if (description) {
                    setMessageBox({status: 'error', title, description})
                }
            })
    }

    return (
        <Modal open={open}>
            <div className="container">
                <div className="content">
                    {mobile ? (
                        <>
                            <div className="header">
                                <Typography variant="h6" color="text.primary">
                                    {connected ? 'Update Service Payors' : 'Add Service Payors Credential'}
                                </Typography>
                                <IconButton onClick={() => setOpen(false)}>
                                    <Close />
                                </IconButton>
                            </div>
                            <div className="actions">
                                <Button variant="outlined" onClick={() => setOpen(false)} style={{flex: 1}}>
                                    Back
                                </Button>
                                <Button
                                    variant="contained"
                                    fullWidth
                                    color={connected ? 'primary' : 'error'}
                                    onClick={form.handleSubmit(changeCredential)}
                                    style={{flex: 1}}>
                                    {connected ? 'Save' : 'Add'}
                                </Button>
                            </div>
                            <br />
                            <br />
                            <br />
                            <br />
                        </>
                    ) : (
                        <Typography variant="h6" color="text.primary" className="title">
                            {connected ? 'Update Service Payors' : 'Add Service Payors Credential'}
                        </Typography>
                    )}
                    <br />
                    <Typography variant="h6" color="primary">
                        {data?.branch?.branch_name}
                    </Typography>
                    <br />
                    <Typography variant="h8" color="text.primary">
                        {data?.payer?.payer_name}
                    </Typography>
                    <br />
                    {connected ? (
                        <Chip icon={<CheckCircleOutline fontSize="small" />} label="Connected" variant="outlined" color="success" size="small" />
                    ) : (
                        <Chip
                            icon={<WarningAmberOutlined fontSize="small" />}
                            label="Credentials not set — this payor cannot submit until saved"
                            variant="outlined"
                            color="error"
                            size="small"
                        />
                    )}
                    <br />
                    <br />
                    <Typography variant="inputLabel" color="text.secondary">
                        Username{' '}
                        <Typography variant="inputLabel" color="error">
                            *
                        </Typography>
                    </Typography>
                    <TextField
                        placeholder="Enter your username"
                        fullWidth
                        {...form.register('username')}
                        error={!!form.formState.errors?.username}
                        helperText={form.formState.errors?.username?.message}
                    />
                    <br />
                    <br />
                    <Typography variant="inputLabel" color="text.secondary">
                        Password{' '}
                        <Typography variant="inputLabel" color="error">
                            *
                        </Typography>
                    </Typography>
                    <FormControl error={!!form.formState.errors['password']} variant="standard" fullWidth>
                        <OutlinedInput
                            placeholder="Enter your password"
                            {...form.register('password')}
                            type={showPassword ? 'text' : 'password'}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton onClick={() => setShowPassword(!showPassword)} onMouseDown={e => e.preventDefault()}>
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                        <FormHelperText>{form.formState.errors['password']?.message}</FormHelperText>
                    </FormControl>
                    <br />
                    <br />
                    {mobile ? (
                        <>
                            <br />
                            <br />
                            <br />
                            <br />
                        </>
                    ) : (
                        <div className="actions">
                            <Button onClick={() => setOpen(false)} variant="outlined" fullWidth>
                                Cancel
                            </Button>
                            <Button variant="contained" fullWidth color={connected ? 'primary' : 'error'} onClick={form.handleSubmit(changeCredential)}>
                                {connected ? 'Save Changes' : 'Add Payors'}
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        </Modal>
    )
}
